import EventManager from 'dd-event-manager';

const ev = {};
new EventManager(ev);

let LS_ENABLED = false;

try {
  if (typeof window.localStorage === 'object' && window.localStorage !== null) {
    localStorage.setItem('__dnls_detect__', 'enabled');
    if (localStorage.getItem('__dnls_detect__') === 'enabled') {
      localStorage.removeItem('__dnls_detect__');
      LS_ENABLED = true;
    }
  }
} catch(e) {}

export default {
  namespaced: true,

  state: {
    initialized: false,
    localStorageEnabled: LS_ENABLED,
    cookieEnabled: navigator.cookieEnabled,
    isPrivateBrowse: null,
  },

  getters: {
    localStorageEnabled: state => state.localStorageEnabled,
    cookieEnabled: state => state.cookieEnabled,
    isPrivateBrowse: state => state.isPrivateBrowse,
    storageEnabled: state => state.localStorageEnabled && state.cookieEnabled,
    isIdbNotSupport: (state, getters, rootState, rootGetters) => {
      return rootGetters['ua/isAny'](['lte-ie10', 'lt-safari10'])
          || (rootGetters['ua/is']('ios') && rootState.ua.os.version <= 9);
    },
    idbEnabled: (state, getters) => !state.isPrivateBrowse && getters['storageEnabled'] && !getters['isIdbNotSupport'],
  },

  actions: {
    init: async ({dispatch, commit}) => {
      await dispatch('detectPrivateBrowse');
      commit('setInitialized');
    },
    ready: () => {
      return new Promise(resolve => {
        ev.hasAndOn('init', resolve);
      });
    },
    detectPrivateBrowse: ({ state, dispatch, commit, getters, rootGetters }) => {
      const maxRetry = 50,
            interval = 10;

      const retry = (isDone, next) => {
        let currentTrial = 0,
            isTimeout    = false;

        const intervalId = window.setInterval(() => {
          if (isDone()) {
            window.clearInterval(intervalId);
            next(typeof next !== 'function' ? next : isTimeout);
          }

          if (currentTrial++ > maxRetry) {
            window.clearInterval(intervalId);
            isTimeout = true;
            next(isTimeout);
          }
        }, interval);
      }

      return new Promise(resolve => {
        if (rootGetters['ua/is']('chrome')) {

          // >>> Chrome
          if (window.webkitRequestFileSystem) {
            return window.webkitRequestFileSystem(window.TEMPORARY, 1, () => {
              commit('setIsPrivateBrowse', false);
              return resolve();
            }, e => {
              commit('setIsPrivateBrowse', true);
              return resolve();
            });
          }
        } else if (rootGetters['ua/is']('firefox')) {

          // >>> Firefox
          try {
            if (window.indexedDB) {
              const db = window.indexedDB.open('dn_detect_db');

              return retry(
                () => {
                  return db.readyState === 'done' ? true : false;
                },
                isTimeout => {
                  if (!isTimeout) {
                    commit('setIsPrivateBrowse', db.result ? false : true);
                    return resolve();
                  }
                }
              );
            } else {
              commit('setIsPrivateBrowse', true);
              return resolve();
            }
          } catch(e) {
            commit('setIsPrivateBrowse', true);
            return resolve();
          }
        } else if (rootGetters['ua/is']('gte-ie10')) {

          // >>> get IE10
          let isPrivate = false;

          try {
            if (!window.indexedDB) {
              isPrivate = true;
            }
          } catch (e) {
            isPrivate = true;
          }

          commit('setIsPrivateBrowse', isPrivate);
          return resolve();
        } else if (rootGetters['ua/is']('safari')) {

          // >>> Safari
          commit('setIsPrivateBrowse', !getters['localStorageEnabled']);
          return resolve();
        }

        commit('setIsPrivateBrowse', false);
        resolve();
      });
    },
  },
  mutations: {
    setInitialized: (state, initialized = true) => {
      state.initialized = initialized;
      if (initialized) {
        ev.emit('init');
      }
    },
    setIsPrivateBrowse: (state, isPrivateBrowse) => {
      state.isPrivateBrowse = isPrivateBrowse;
    },
  },
}


// WEBPACK FOOTER //
// ./src/js/store/modules/browser.js